import axios from 'axios';
// Constantes a utilizar en la aplicación

/** DESARROLLO */
//export const CAFFENIO_AUTH_URL = "http://auth.vasopinguino.com";  //DEV
//export const CAFFENIO_AUTH_URL = "https://qaauth.caffenio.com"; //PREPROD
export const CAFFENIO_AUTH_URL = "https://auth.caffenio.com"; //PROD

export const CAFFENIO_AUTH_PSW_RESTORE = `${CAFFENIO_AUTH_URL}/change-password`;

//export const CAFFENIO_AUTH_ID = "451252E5-7255-433C-A0BA-349AEF77B7C1"; //DEV
export const CAFFENIO_AUTH_ID = "0CBB8E42-2D4E-48DA-9FE1-64103E825BFD"; //PROD

//export const API_URL = "http://localhost:8000/api";  //LOCAL
//export const API_URL = "http://apiinventarios.vasopinguino.com:9103/api";  //DEV
// export const API_URL = "http://apiinventariosbarra.vasopinguino.com:9302/api";  //DEV
//export const API_URL = "https://qaapiinventariosbarra.caffenio.com/api" //PREPROD
export const API_URL = "https://apiinventarios.caffenio.com/api" //PROD

/**
 * Constante para solicitudes
 */
export const REQUEST = axios.create({
    baseURL: API_URL,
    headers: { 
        'Access-Control-Allow-Origin': '*',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type':'application/json' 
    }
})

/**
 * Constante para la solicitud a CAFFENIO Auth
 */
export const AUTH_REQUEST = axios.create({
    baseURL: CAFFENIO_AUTH_URL,
    headers: { 'Content-Type':'application/x-www-form-urlencoded' }
})

export const Drive = 1
export const Barra = 2

/**
 * Constante para generar el menú dinamicamente
 */
export const MENU = {
    
}